import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild} from '@angular/router';
import {Observable} from 'rxjs';
import {AppStateService} from '@core/service/app-state.service';

@Injectable()
export class MustBeSignedUpCompany implements CanActivateChild {

  constructor(private router: Router, private appState: AppStateService) {
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.appState.isSignedUp()) {
      return true;
    } else {
      this.router.navigate(['/signup/step1'], {skipLocationChange: true, replaceUrl: true}).then(() => false);
      return false;
    }
  }
}
